import { InputDiv } from "components/core/BaseTable/styles";
import React from "react";

function SearchBar({ value, onChange }) {
  return (
    // <InputDiv style={{ width: "50%", maxWidth: "36rem", padding: "0" }}>
    <div>
      <input
        value={value}
        onChange={onChange}
        // className="input-elevated"
        className="custom-input-elevated"
        type="text"
        // placeholder="Search with Employee No. or Patient Name"
        placeholder="Search"
      />
    {/* </InputDiv> */}
    </div>
  );
}

export default SearchBar;
